import type { FC } from 'react';

// JSON-LD structured data lives in a non-executable <script>, so it needs
// dangerouslySetInnerHTML to emit the raw JSON.
export const JsonLd: FC<{ data: object }> = ({ data }) => (
  <script
    type="application/ld+json"
    // biome-ignore lint/security/noDangerouslySetInnerHtml: required for JSON-LD
    dangerouslySetInnerHTML={{
      __html: JSON.stringify(data).replace(/</g, '\\\\u003c'),
    }}
  />
);
